// extracted by mini-css-extract-plugin
module.exports = {"fullscreen_container":"FullscreenContainer-module--fullscreen_container--3eCe_"};